export default {
  blocks: [],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        src: { width: 1000, height: 637, file_name: 'first_image.jpg', original_file_name: 'blob' },
        isLoading: false,
        config: { size: 'fullWidth', alignment: 'center', textWrap: 'wrap' },
      },
    },
  },
};
